import Vue from 'vue'
import Register from './App'
require('common/js/common-include');

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<register />',
  components: {Register},
  beforeCreate:function(){ this.doAfterSyncLogin(this, null, true, 3) }
});



// WEBPACK FOOTER //
// ./src/modules/register/register.js